import React from 'react';

const OurStory = () => {
  return (
    <div className="min-h-screen pt-20 bg-black relative" style={{
      backgroundImage: `
        linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)),
        url("/images/backgrounds/bar-bg.webp"),
        url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23eab308' fill-opacity='0.03'%3E%3Cpath d='m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
      `,
      backgroundSize: 'cover, cover, 60px 60px',
      backgroundPosition: 'center, center, 0 0',
      backgroundRepeat: 'no-repeat, no-repeat, repeat',
      backgroundAttachment: 'fixed, scroll, scroll'
    }}>
      <div className="container mx-auto px-4 py-16">
        <h1 className="section-title mb-12">Our Story</h1>
        
        <div className="max-w-4xl mx-auto">
          {/* Hero Image */}
          <div className="mb-12 rounded-lg overflow-hidden shadow-2xl">
            <img 
              src="/images/backgrounds/dining-bg.webp" 
              alt="Restaurant Interior - Warm and Welcoming Atmosphere" 
              className="w-full h-64 md:h-96 object-cover"
            />
          </div>

          {/* Story Content */}
          <div className="prose prose-lg prose-invert max-w-none">
            <div className="text-gray-200 leading-relaxed space-y-6 text-lg">
              <p>
                Ultimate Bar & Grill in Mooresville, NC, is a testament to community revitalization and the power of local ownership. Located at 455 East Plaza Drive, this beloved local spot was formerly known as Ten O'Clock Charlie's—a neighborhood favorite known for its hearty food, laid-back vibe, and friendly service.
              </p>
              
              <p>
                In 2021, Joe took the reins with a vision: to breathe new life into the bar while preserving its welcoming essence. A familiar face to many in Mooresville, Joe brought passion, purpose, and a strong community focus to the transformation.
              </p>
              
              <p>
                Under his leadership, the bar was reimagined and rebranded as Ultimate Bar & Grill. The refreshed space features an upgraded menu filled with American comfort food favorites like signature wings, burgers, and brisket quesadillas. Regular live music, karaoke nights, and game-day watch parties have turned the bar into a go-to community hub.
              </p>
              
              <p>
                Today, Ultimate Bar & Grill is more than a place to grab a bite or a drink—it's a space where locals come together, friendships are made, and good times are always on the menu. We're proud to be family-owned, community-driven, and deeply rooted in Mooresville tradition.
              </p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="mt-16 text-center relative overflow-hidden rounded-lg" style={{
            background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%)'
          }}>
            <div className="absolute inset-0 bg-gradient-to-r from-yellow-400/10 to-transparent"></div>
            <div className="relative p-8">
              <h2 className="text-3xl font-bold text-white mb-4">Experience Our Story</h2>
              <p className="text-gray-200 mb-8">
                Come be part of our continuing story. Join us for great food, drinks, and community spirit.
              </p>
              <div className="space-y-4 md:space-y-0 md:space-x-4 md:flex md:justify-center">
                <a href="/menu" className="btn-primary inline-block">
                  View Our Menu
                </a>
                <a href="tel:+17047999771" className="btn-secondary inline-block">
                  Call Us
                </a>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-16 grid md:grid-cols-2 gap-8">
            <div className="relative overflow-hidden rounded-lg" style={{
              background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
            }}>
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-400 to-yellow-600"></div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-yellow-400 mb-4">Our Mission</h3>
                <p className="text-gray-200">
                  To create a welcoming space where the Mooresville community can come together to enjoy great food, drinks, and entertainment while building lasting friendships and memories.
                </p>
              </div>
            </div>
            
            <div className="relative overflow-hidden rounded-lg" style={{
              background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
            }}>
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-400 to-yellow-600"></div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-yellow-400 mb-4">Community Focus</h3>
                <p className="text-gray-200">
                  We're more than just a restaurant—we're a community hub that supports local events, hosts live music, and provides a gathering place for neighbors to connect.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurStory; 